import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { IProgramType, updateProgramType } from 'legacy/lut/features/partner360/configuration'
import { TAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { dropAcknowledgement } from 'legacy/lut/services/partner360/commitment/dropAcknowledgement'
import { IApiCommitmentStatus } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentStatus'
import { getJBPPartnerBasicInfoCrudWithKey } from 'legacy/lut/services/partner360/configuration/helpers/getJBPPartnerBasicInfoCrudWithKey'

import { CrudStore } from 'core/types/crudStore'
import { switchOffering } from 'partner360/services/offerings/switchOffering'

interface IToggleOffering {
  flag: boolean
  offering: IProgramType
  isDistributor: boolean
  commitmentStatuses: IApiCommitmentStatus[]
  partnerId: string
  fYear: number
  ownerId: string
  dispatch: TAppDispatch
}

const updateOfferingStatus = async ({
  partnerId,
  offering,
  fYear,
  dispatch,
}: Pick<IToggleOffering, 'offering' | 'partnerId' | 'fYear' | 'dispatch'>) => {
  await switchOffering({
    partnerId,
    fYear,
    programType: offering.programType,
    enabled: !offering.enabled,
  })
  // Позволит быстрее обновить состояние switch сразу после завершения запроса на обновление
  const nextEnabledState = !offering.enabled
  dispatch(
    updateProgramType({
      ...offering,
      enabled: nextEnabledState,
    })
  )

  const crudBasicInfo = CrudStore.get(CrudStoreItemPartner360.PartnerBasicInfo)
  crudBasicInfo.removeQueries(true)
  const partnerDataCrud = getJBPPartnerBasicInfoCrudWithKey(partnerId, fYear)
  partnerDataCrud.removeQueries(true)
}

export const toggleOffering = async ({
  flag,
  offering,
  isDistributor,
  commitmentStatuses,
  partnerId,
  fYear,
  ownerId,
  dispatch,
}: IToggleOffering) => {
  if (isDistributor && flag) {
    // TODO: When CommitmentStatuses are removed, rework this distributor flow to determine
    // acknowledged offerings from CompletenessData, then remove commitmentStatuses from
    // IToggleOffering and all toggleOffering call sites without losing dropAcknowledgement.
    const acknowledgedItems = commitmentStatuses.filter(
      (el) => el.CommitmentStatusKey === 'jbp-commitment-extstatus-acknowledged'
    )

    const promises = acknowledgedItems.map((el) => {
      return dropAcknowledgement({
        programType: el.ProgramType,
        partnerId,
        fYear,
        ownerId,
        comment: `Offering ${el.ProgramType} was switched on manually`,
      })
    })

    await Promise.all(promises)
  }

  await updateOfferingStatus({ offering, fYear, dispatch, partnerId })

  dispatch(
    requestRecalculateCompleteness({
      partnerId,
      fYear,
    })
  )
}
